export const breadcrumbItems = [
  {
    id: 1,
    title: 'Pacientes',
    active: false,
  },
  {
    id: 2,
    title: 'Atendimentos',
    active: false,
  },
  {
    id: 3,
    title: 'Detalhes do atendimento',
    active: true,
  },
]

export const appointmentHistoryBreadcrumbItems = [
  {
    id: 1,
    title: 'Histórico de agendamentos',
    active: false,
  },
  {
    id: 2,
    title: 'Detalhes do atendimento',
    active: true,
  },
]

export const headersServiceDetails = [
  'ID',
  'Nome do paciente',
  'CPF',
  'Telefone',
  'Clínica',
]

export const headersOutgoingCall = [
  'Data/Hora início',
  'Data/ Hora fim',
  'Tipo Meeting',
  'Duração',
  '',
]

export const headersChargeAttempt = [
  'ID da transação',
  'Data/Hora da tentativa',
  'Operação',
  'Status',
  'Usuário',
]

export const headersReschedule = [
  'Data/Hora Original',
  'Data/Hora Reagendada',
  'Data/Hora do reagendamento',
  'Perfil Usuário Responsável',
  'ID Usuário Responsável',
  'Nome Usuário Responsável',
  'ID Usuário Profissional',
  'Nome Usuário Profissional',
]

export enum ServiceDetailsModal {
  'PAYMENT_REVERSE' = 'PAYMENT_REVERSE',
  'CHARGES_OUTCOMES' = 'CHARGES_OUTCOMES',
  'VIEW_OR_ATTACH_FILES' = 'VIEW_OR_ATTACH_FILES',
  'REFUND_DETAILS' = 'REFUND_DETAILS',
}

export const DEFAULT_CANCEL_REASON = 'Motivo do cancelamento não informado.'
export const OTHERS_CANCEL_CATEGORY = 'Outros'
